import React from "react";
import { useTranslation } from "react-i18next";
import { Loader2 } from "lucide-react";

export default function ChatHistoryLoadMore({ onLoadMore, isLoadingMore }) {
    const { t } = useTranslation();

    return (
        <div className="px-4 py-3 border-t border-gray-100">
            <button
                onClick={onLoadMore}
                disabled={isLoadingMore}
                className="w-full inline-flex items-center justify-center gap-2 text-xs font-medium text-blue-600 hover:text-blue-700 disabled:opacity-50 py-1"
            >
                {isLoadingMore && (
                    <Loader2 className="w-3.5 h-3.5 animate-spin" />
                )}
                {t("chatTwoColumnPage.loadMoreConversations")}
            </button>
        </div>
    );
}
